import React from "react";
import { Nav, Navbar, NavItem } from "react-bootstrap";
import { goToTheSpecificSectionFunc1 } from "../utils/goToTheSpecificSection";

export default class Navigation extends React.Component {
    constructor() {
        super();
        this.state = {
            marginBottom: 0,
            turn: 0
        };
        this.goToTheSpecificSection = this.goToTheSpecificSection.bind(this);
    }
    goToTheSpecificSection(e) {
        return goToTheSpecificSectionFunc1(e, this);
    }
    handleResponsiveNavigation = () => {
        if (this.state.turn === 0) this.setState({ marginBottom: 160, turn: 1 });
        else this.setState({ marginBottom: 0, turn: 0 });
    }
    render() {
        const innerStyles = {
            navBarContainer: {
                backgroundColor: "#c80a48",
                border: 0,
                borderRadius: 0,
                height: 80,
                paddingTop: 17,
                marginBottom: this.state.marginBottom
            }
        }
        return (
            <Navbar style={innerStyles.navBarContainer} collapseOnSelect>
                <Navbar.Header>
                    <Navbar.Brand>
                        <a href="/" style={styles.navBrand}>Creative</a>
                    </Navbar.Brand>
                    <Navbar.Toggle style={styles.navBarToggle} onClick={this.handleResponsiveNavigation} />
                </Navbar.Header>
                <Navbar.Collapse style={styles.navBarCollapse}>
                    <Nav pullRight>
                        {/* <NavItem style={styles.active} className="active" onClick={_ => { this.goToTheSpecificSection(this.props.home); }} eventKey={1} href="JavaScript:void(0)">
                            Home
                        </NavItem> */}
                        <NavItem style={styles.eachNavItem} eventKey={2} onClick={_ => { this.goToTheSpecificSection(this.props.about); }} href="JavaScript:void(0)">
                            About Me
                        </NavItem>
                        <NavItem style={styles.eachNavItem} eventKey={3} onClick={_ => { this.goToTheSpecificSection(this.props.skills); }} href="JavaScript:void(0)">
                            Skills
                        </NavItem>
                        <NavItem style={styles.eachNavItem} eventKey={4} onClick={_ => { this.goToTheSpecificSection(this.props.portfolio); }} href="JavaScript:void(0)">
                            Portfolio
                        </NavItem>
                        <NavItem style={styles.eachNavItem} eventKey={5} onClick={_ => { this.goToTheSpecificSection(this.props.contact); }} href="JavaScript:void(0)">
                            Contact Me
                        </NavItem>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        );
    }
}

const styles = {
    navBrand: {
        color: "#fff",
        fontWeight: 600,
        textTransform: "uppercase"
    },
    navBarCollapse: {
        backgroundColor: "#c80a48"
    },
    navBarToggle: {
        borderWidth: 0
    }
};


// WEBPACK FOOTER //
// ./src/Components/navigation.jsx